import React, {useEffect} from 'react';

import '../../App.css';
import {useParams} from "react-router-dom";
import {useAppDispatch, useAppSelector} from "../../feature/tools";
import {Status} from "../../feature/project/status";
import {ViewMode} from "../common/ViewMode";
import {fetchScenes} from "../../feature/project/sceneSlice";
import {List, NumericList} from "../common/ListItems";

const Scenes = (props: {}) => {

    const dispatch = useAppDispatch()
    const {projectId, actId, storyId, chapterId} = useParams();
    const scenes = useAppSelector(state => state.scenes.scenes)
    const status = useAppSelector(state => state.scenes.status)

    useEffect(() => {
        if (status === Status.Idle && projectId && chapterId) {
            dispatch(fetchScenes({projectId: parseInt(projectId), chapterId: parseInt(chapterId)}))
        }
    }, [status, dispatch])

    return (
        <NumericList
            items={scenes}
            path={(id) => `/projects/${projectId}/stories/${storyId}/acts/${actId}/chapters/${chapterId}/scenes/${id}`}
        />
    );
}

export default Scenes;